// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchNotFound_root__OjWK0","wrapper":"SearchNotFound_wrapper__vJCCF","highlight":"SearchNotFound_highlight____Grj"};